import { Type } from "class-transformer";
import { EnaioWorkflowDataType } from "./EnaioWorkflowDataType";

export class EnaioWorkflowDataMember {
    name: string;
    @Type(() => EnaioWorkflowDataType)
    dataType: EnaioWorkflowDataType;
}
